import script from "./SeletorComponenteVue.vue?vue&type=script&setup=true&lang=js"
export * from "./SeletorComponenteVue.vue?vue&type=script&setup=true&lang=js"

import "./SeletorComponenteVue.vue?vue&type=style&index=0&id=bd05091a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd05091a"]])

export default __exports__